/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points Over Time`)
};

const es_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos a lo largo del tiempo`)
};

const de_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkte im Zeitverlauf`)
};

const nl_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punten in de loop van de tijd`)
};

const fr_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points dans le temps`)
};

const it_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti nel tempo`)
};

const pt_br2_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos ao longo do tempo`)
};

const pt_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos ao longo do tempo`)
};

const ja_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポイント推移`)
};

const zh_f1_profile_chart_points_over_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分随时间变化`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_chart_points_over_time = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_chart_points_over_time(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_chart_points_over_time", locale)
	if (locale === "en") return en_f1_profile_chart_points_over_time(inputs)
	if (locale === "es") return es_f1_profile_chart_points_over_time(inputs)
	if (locale === "de") return de_f1_profile_chart_points_over_time(inputs)
	if (locale === "nl") return nl_f1_profile_chart_points_over_time(inputs)
	if (locale === "fr") return fr_f1_profile_chart_points_over_time(inputs)
	if (locale === "it") return it_f1_profile_chart_points_over_time(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_chart_points_over_time(inputs)
	if (locale === "pt") return pt_f1_profile_chart_points_over_time(inputs)
	if (locale === "ja") return ja_f1_profile_chart_points_over_time(inputs)
	return zh_f1_profile_chart_points_over_time(inputs)
};